import { ID } from '../../app/models/id';
import { environment } from '../../environments/environment';

export const addForethoughtLoadingScript = (companyId: ID, firstName: string): void => {
  if (document.getElementById('forethought-widget-embed-script')) {
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'forethought-widget-embed-script';
  script.src = 'https://solve-widget.forethought.ai/embed.js';
  script.async = true;
  script.defer = true;
  script.setAttribute('data-api-key', environment.forethoughtApiKey);
  script.setAttribute('data-ft-workflow-tag', 'CRU');

  if (companyId) {
    script.setAttribute('data-ft-Company-ID', String(companyId));
  }

  if (firstName) {
    script.setAttribute('data-ft-First-Name', firstName);
  }

  document.body.appendChild(script);
};

export const removeForethoughtWidget = (): void => {
  const existing = document.getElementById('forethought-widget-embed-script');
  if (existing) {
    existing.remove();
  }

  const iframe = document.querySelector('iframe[src*="forethought"]');
  if (iframe) {
    iframe.remove();
  }
};
